export const initModal = () => {
  $(document).on('click', '[data-modal-btn]', function (e) {
    e.preventDefault()

    const idModal = $(this).data('modal-btn')

    const modal = $(`[data-modal="${idModal}"]`)
    document.body.classList.add('disable-scroll');
    const sidebarNavigation = $('.tr-sidebar-navigation')

    if (modal && modal.hasClass('invisible')) {
      modal.removeClass('invisible').addClass('visible')
      $(document).trigger('openModal', [idModal])
      sidebarNavigation ? sidebarNavigation.addClass('hide') : null
    }
  })

  $(document).on('click', function (e) {

    if (!$('[data-modal]')) return

    if ($(e.target).is('[data-modal], [data-modal-btn-close]')) {
      e.preventDefault()

      const idModal = $(e.target).is('[data-modal]') ? $(e.target).data('modal') : $(e.target).closest('[data-modal]').data('modal')

      const sidebarNavigation = $('.tr-sidebar-navigation')

      $('[data-modal]').addClass('invisible').removeClass('visible')
      $(document).trigger('closeModal', [idModal])
      document.body.classList.remove('disable-scroll');
      sidebarNavigation ? sidebarNavigation.removeClass('hide') : null
    }
  })
}
